// removed by extract-text-webpack-plugin
module.exports = {"okEmail":"_1ssx0ByGY6 label","okEmailFormGroup":"_1F3HH3eVuM","form":"_1JRXNSEWUU"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/forms/secure/profile/ProfileForm/ProfileForm.module.less
// module id = 481
// module chunks = 3